import { postMutation } from '@/lib/react-query/mutate';

const login = 'login';

export const useAuthMutation = () =>
  postMutation({
    endpoint: login,
    requestOptions: {
      unauthorized: 'Incorrect username or password.',
      requestLimit: 'Too many failed login attempts. Please try again later.',
    },
    mutationOptions: {
      meta: {
        avoidAuthRedirection: true,
      },
    },
  });
